import { Model } from 'core/models';
import { Moment } from 'moment';
import { Status } from './Status';



export class LicenseInformation extends Model {
  public id?: number;
  public code?: string;
  public name?: string;
  public startedAt?:Moment;
  public expiredAt?:Moment;
  public warnedAt?:Moment;
  public licenseStatus?:Status;
  public content?:string;
}
